export default "__VITE_ASSET__CvDbiYnc__"